import {
  SET_CURRENT_USER,
  SET_USER_PERMISSIONS,
  SET_SELECTED_ART_EVENT_ID,
  SET_SELECTED_ART_EVENT_STATUS,
  SET_SELECTED_NAVIGATION_ID,
  SharedActionTypes,
} from '../actions/types';

export interface SharedState {
  selectedNavigationId: string;
  selectedArtEventId: string | null | undefined;
  selectedArtEventStatus: string | null | undefined;
  currentUser: {
    userId: string;
    role: string;
    firstName: string;
    lastName: string;
    email: string;
    permissions: string[] | null;
    privilegedMode: boolean;
  } | null;
}

export const initialSharedState: SharedState = {
  selectedNavigationId: 'dashboard',
  selectedArtEventId: null,
  selectedArtEventStatus: null,
  currentUser: null,
};

export const appReducer = (
  state = initialSharedState,
  action: SharedActionTypes
): SharedState => {
  switch (action.type) {
    case SET_SELECTED_NAVIGATION_ID:
      return {
        ...state,
        selectedNavigationId: action.payload,
      };
    case SET_CURRENT_USER:
      return {
        ...state,
        currentUser: {
          ...action.payload,
          permissions:
            state.currentUser?.userId === action.payload.userId
              ? (state.currentUser?.permissions ?? null)
              : null,
        },
      };
    case SET_USER_PERMISSIONS:
      return {
        ...state,
        currentUser: state.currentUser
          ? { ...state.currentUser, permissions: action.payload }
          : null,
      };
    case SET_SELECTED_ART_EVENT_ID:
      return {
        ...state,
        selectedArtEventId: action.payload,
      };
    case SET_SELECTED_ART_EVENT_STATUS:
      return {
        ...state,
        selectedArtEventStatus: action.payload,
      };
    default:
      return state;
  }
};
